import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./computo-videoconferencia.css";
import negociosDigitalesImg from "./img-domotic/nregociosdigitales.png"

const NegociosDigitales = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Negocios Digitales
  const imagenesGaleria = [
    { src: negociosDigitalesImg, alt: "Negocios Digitales", caption: "Modalidad renting con opción de compra" },
  ];

  const servicios = [
    // Puedes añadir servicios específicos si es necesario
  ];

  const tiposSoluciones = [
    {
      categoria: "Equipamiento Tecnológico",
      items: [
        "Computadores de alto rendimiento",
        "Servidores empresariales",
        "Impresoras multifuncionales",
        "Dispositivos de red"
      ]
    },
    {
      categoria: "Sistemas de Gestión",
      items: [
        "Sistema de gestión documental",
        "Plataformas de automatización",
        "Soluciones de backup y respaldo",
        "Herramientas de colaboración"
      ]
    },
    {
      categoria: "Modalidad Renting",
      items: [
        "Opción de compra final",
        "Mantenimiento incluido",
        "Actualizaciones periódicas",
        "Soporte técnico 24/7"
      ]
    }
  ];

  const marcas = [
    { nombre: "Dell", logo: "/marcas/dell.png" },
    { nombre: "HP", logo: "/marcas/hp.png" },
    { nombre: "Lenovo", logo: "/marcas/lenovo.png" },
    { nombre: "Canon", logo: "/marcas/canon.png" },
    { nombre: "Epson", logo: "/marcas/epson.png" },
    { nombre: "Microsoft", logo: "/marcas/microsoft.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.computo-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="computo-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="computo-hero">
        <div className="computo-hero-content">
          <h1 className="computo-hero-title">Negocios Digitales</h1>
          <p className="computo-hero-subtitle">
            Modalidad renting con opción de compra - La solución tecnológica completa para tu empresa
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="computo-gallery computo-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="computo-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="computo-gallery-img"
            />
            <div className="computo-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Sección de Características con Imágenes de Fondo */}
      <section className="ryn-features-section">
        <div className="ryn-features-container">
          <h2 className="ryn-features-title">Nuestras Soluciones en Negocios Digitales</h2>
          <p className="ryn-features-subtitle">Tecnología de vanguardia con financiamiento flexible para el crecimiento de tu empresa</p>
          
          <div className="ryn-features-grid">
            {/* Característica 1 */}
            <div className="ryn-feature-card">
              <div className="ryn-feature-content">
                <h3 className="ryn-feature-title">Modalidad Renting con Opción de Compra</h3>
                <ul className="ryn-feature-list">
                  <li>Computadores de última generación</li>
                  <li>Servidores empresariales escalables</li>
                  <li>Impresoras y equipos multifuncionales</li>
                  <li>Sistema de gestión documental integrado</li>
                 
                </ul>
              </div>
            </div>
            
         
          </div>
        </div>
      </section>  

     

    </div>
  );
};

export default NegociosDigitales;